import React, { createContext, useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { AuthAPI } from './api';

export interface User {
  id: number;
  tgId: number;
  tgFirstName: string;
  tgLastName?: string;
  tgUsername?: string;
  tgPhotoUrl?: string;
}

const AuthContext = createContext<{ user: User | null; isLoading: boolean }>({
  user: null,
  isLoading: true,
});

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const { data: user, isLoading } = useQuery<User | null>({
    queryKey: ['me'],
    queryFn: async () => {
      try {
        return await AuthAPI.me();
      } catch {
        return null;
      }
    },
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  return (
    <AuthContext.Provider value={{ user: user ?? null, isLoading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useMe() {
  return useContext(AuthContext);
}

export function AuthGuard({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useMe();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen" style={{ background: 'var(--tg-bg)' }}>
        <div className="text-tg-text-secondary">Завантаження...</div>
      </div>
    );
  }

  if (!user) {
    window.location.href = '/login';
    return null;
  }

  return <>{children}</>;
}
